import {useState, useEffect} from "react";
import {
  IResponseAll,
  IResponseDriver,
  IResponseInitiativesSegment,
  IResponseParticipants,
  ICRGCIResponse,
} from "../pages/StateInitiative/StateInitiative.type";

const useFetchDataStateInitiative = (
  apiUrlCRGCI: string,
  apiKeyCRGCI: string
) => {
  const [initiativesData, setInitiativesData] =
    useState<IResponseInitiativesSegment | null>(null);
  const [allData, setAllData] = useState<IResponseAll | null>(null);
  const [driverData, setDriverData] = useState<IResponseDriver | null>(null);
  const [participants, setparticipantsData] =
    useState<IResponseParticipants | null>(null);
  const [crgciData, setCrgciData] = useState<ICRGCIResponse | null>(null);
  const [error, setError] = useState<Error | null>(null);
  const [availableFields, setAvailableFields] = useState<{
    authorities: boolean;
    lifecycle_stage: boolean;
    obligation_level: boolean;
    business_impact: boolean;
    noncompliance_risks: boolean;
    has_benefits: boolean;
    participation_formats: boolean;
  }>({
    authorities: false,
    lifecycle_stage: false,
    obligation_level: false,
    business_impact: false,
    noncompliance_risks: false,
    has_benefits: false,
    participation_formats: false,
  });

  useEffect(() => {
    if (!apiUrlCRGCI) {
      setError(new Error("CRGCI API URL не может быть пустым"));
      return;
    }

    if (!apiKeyCRGCI) {
      setError(new Error("CRGCI API ключ не может быть пустым"));
      return;
    }

    try {
      const headersCRGCI = new Headers({
        Authorization: `Bearer ${apiKeyCRGCI}`,
        "Content-Type": "application/json",
      });

      const crgciUrl = new URL(apiUrlCRGCI);
      crgciUrl.searchParams.set("pagination[pageSize]", "500");
      crgciUrl.searchParams.set("populate[segments][populate]", "*");
      crgciUrl.searchParams.set("populate[authorities][populate]", "*");

      const initiativesUrl = new URL(
        apiUrlCRGCI.replace("/api/crgci", "/api/initiatives")
      );
      initiativesUrl.searchParams.set("pagination[pageSize]", "500");
      initiativesUrl.searchParams.set("populate", "*");

      Promise.all([
        fetch(crgciUrl.href, {headers: headersCRGCI}).then((response) => {
          if (!response.ok) {
            throw new Error(
              `HTTP ${response.status}: ${response.statusText} для CRGCI URL: ${crgciUrl.href}`
            );
          }
          return response.json();
        }),
        fetch(initiativesUrl.href, {headers: headersCRGCI}).then((response) => {
          if (!response.ok) {
            throw new Error(
              `HTTP ${response.status}: ${response.statusText} для initiatives URL: ${initiativesUrl.href}`
            );
          }
          return response.json();
        }),
      ])
        .then(([crgciData, initiativesResponse]) => {
          const crgciDataWithInitiatives = {
            ...crgciData,
            data: {
              ...crgciData.data,
              initiatives: initiativesResponse.data,
            },
          };

          if (crgciDataWithInitiatives?.data?.initiatives?.length > 0) {
            const firstInitiative =
              crgciDataWithInitiatives.data.initiatives[0];

            const fields = {
              authorities: firstInitiative.authorities?.length > 0,
              lifecycle_stage: firstInitiative.lifecycle_stage !== null,
              obligation_level: firstInitiative.obligation_level !== null,
              business_impact: firstInitiative.business_impact !== null,
              noncompliance_risks: firstInitiative.noncompliance_risks !== null,
              has_benefits: firstInitiative.has_benefits !== null,
              participation_formats:
                firstInitiative.participation_formats !== null,
            };

            setAvailableFields(fields);

            // const availableCount = Object.values(fields).filter(Boolean).length;

            // if (availableCount === 0) {
            //   console.info(
            //     "ℹ️ CRGCI: Все фильтры используют данные из единого API"
            //   );
            // } else {
            //   console.info(
            //     `ℹ️ CRGCI: Доступно ${availableCount} полей для фильтров`
            //   );
            // }
          }

          // Используем объединённые данные для всех состояний
          setInitiativesData(crgciDataWithInitiatives);
          setAllData(crgciDataWithInitiatives);
          setDriverData(crgciDataWithInitiatives);
          setparticipantsData(crgciDataWithInitiatives);
          setCrgciData(crgciDataWithInitiatives);
          setError(null);
        })
        .catch((error) => {
          console.error("Ошибка загрузки данных:", error);
          setError(error);
        });
    } catch (error) {
      console.error("Ошибка создания URL:", error);
      setError(
        error instanceof Error ? error : new Error("Неизвестная ошибка")
      );
    }
  }, [apiUrlCRGCI, apiKeyCRGCI]);

  return {
    initiativesData,
    allData,
    driverData,
    participants,
    crgciData,
    availableFields,
    error,
  };
};

export default useFetchDataStateInitiative;
